<template>
  <div
    class="rounded-2xl border border-ink/10 bg-white/70 p-5 sm:border-0 sm:bg-transparent sm:p-4"
    data-testid="info-box"
  >
    <div class="grid gap-5 sm:grid-cols-3 sm:gap-4">
      <div
        v-for="field in infoFields"
        :key="field.key"
        :data-testid="`info-field-${field.key}`"
        class="flex items-center justify-between gap-4 sm:block"
      >
        <p
          class="flex-1 text-left text-xs uppercase tracking-[0.2em] text-slate-500 sm:text-[0.65rem] sm:text-center py-0.5"
        >
          {{ field.label }}
        </p>
        <div
          class="flex-1 flex items-center justify-end text-right sm:mt-1 sm:block sm:text-center"
        >
          <button
            v-if="isInfoHidden(field.key)"
            class="inline-flex items-center justify-end border-0 bg-transparent p-0 text-xs font-semibold uppercase tracking-[0.2em] text-neutral-900/70 underline underline-offset-4 transition hover:text-neutral-900 sm:justify-center sm:rounded-full sm:border sm:border-ink/20 sm:bg-white sm:px-4 sm:py-2 sm:text-xs sm:tracking-[0.2em] sm:text-neutral-900 sm:no-underline sm:hover:border-ink/40"
            type="button"
            @click="handleRevealInfo(field.key)"
            :data-testid="`info-show-${field.key}`"
          >
            {{ t("player-info.button-show") }}
          </button>
          <p
            v-else
            class="text-base font-semibold text-neutral-900 text-sm"
            :data-testid="`info-value-${field.key}`"
          >
            {{ formatInfoValue(field.value) }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch } from "vue";
import { useText } from "../composables/useText.js";

const { t } = useText();

const props = defineProps({
  birthDate: {
    type: String,
    default: "",
  },
  nationality: {
    type: String,
    default: "",
  },
  position: {
    type: String,
    default: "",
  },
  playerId: {
    type: [String, Number],
    default: "",
  },
});

const infoRevealed = ref(new Set());

const toBirthYear = (value) => {
  if (!value) return null;
  const [year] = value.split("-");
  return year || null;
};

const infoFields = computed(() => [
  {
    key: "birthYear",
    label: t("common.birth-year"),
    value: toBirthYear(props.birthDate),
  },
  {
    key: "nationality",
    label: t("common.nationality"),
    value: props.nationality,
  },
  { key: "position", label: t("common.position"), value: props.position },
]);

const isInfoHidden = (key) => {
  return !infoRevealed.value.has(key);
};

const handleRevealInfo = (key) => {
  infoRevealed.value = new Set([...infoRevealed.value, key]);
};

const formatInfoValue = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  return value;
};

watch(
  () => props.playerId,
  () => {
    infoRevealed.value = new Set();
  },
);
</script>
